class PathGenerator {
  static readonly quickSettingParam = 'isSettingsOpen'

  static readonly desktopNotificationsToggleParam = 'enableDesktopNotifications'

  static enableDesktopNotifications = () => `${window.location.origin}/?${PathGenerator.quickSettingParam}=true&${PathGenerator.desktopNotificationsToggleParam}=true`
}

export default PathGenerator;
